import React from "react";
import { CButton, CSpinner } from "@coreui/react";

const TableButtonClick = (props) => {
  const color =
    props.color === null || props.color === undefined ? "success" : props.color;
  const isDisplayAllow =
    props.isDisplayAllow === null ? true : props.isDisplayAllow;
  const isNormallBtn = props.isNormallBtn === null ? false : props.isNormallBtn;
  const isDisabledBtn =
    props.isDisabledBtn === null ? false : props.isDisabledBtn;

  const isBtnLoader =
    props.isButtonLoader === null ? false : props.isButtonLoader;

  return (
    <td className="py-2">
      {
        isDisplayAllow === true &&
          (isNormallBtn === true ? (
            <CButton color={color} onClick={props.onClick}>
              {props.buttonName}
            </CButton>
          ) : isDisabledBtn === true ? (
            isBtnLoader === true ? (
              <CButton
                variant="outline"
                shape="square"
                size="sm"
                disabled={isBtnLoader || props.disabledBtn}
                color={color}
                onClick={props.onClick}
              >
                {isBtnLoader && (
                  <>
                    <CSpinner as="span" size="sm" aria-hidden="true" />
                    &nbsp;
                  </>
                )}
                {props.buttonName}
              </CButton>
            ) : (
              <CButton
                variant="outline"
                shape="square"
                size="sm"
                disabled={props.disabled}
                color={color}
                onClick={props.onClick}
              >
                {props.buttonName}
              </CButton>
            )
          ) : (
            <CButton
              variant="outline"
              shape="square"
              size="sm"
              color={color}
              onClick={props.onClick}
            >
              {props.buttonName}
            </CButton>
          ))
        //)
      }
    </td>
  );
};

export default TableButtonClick;
